/**
 * Shared route definitions for company-level navigation.
 * Used by both the command palette (frontend) and AI navigation (backend).
 */

export interface CompanyRoute {
  key: string
  route: string
  label: string
  description: string
}

export const COMPANY_ROUTES: CompanyRoute[] = [
  {
    key: 'company',
    route: 'company',
    label: 'Home',
    description: 'Company dashboard and overview'
  },
  {
    key: 'foundation',
    route: 'foundation',
    label: 'Company Foundation',
    description: 'Company information and details'
  },
  {
    key: 'insights',
    route: 'insights',
    label: 'Insights',
    description: 'Customer insights and feedback'
  },
  {
    key: 'features',
    route: 'features',
    label: 'Features',
    description: 'Product features and roadmap'
  },
  {
    key: 'competitors',
    route: 'competitors',
    label: 'Competitors',
    description: 'Competitor monitoring and analysis'
  },
  {
    key: 'projects',
    route: 'projects',
    label: 'Projects',
    description: 'Project status tracking'
  },
  {
    key: 'integrations',
    route: 'integrations',
    label: 'Integrations',
    description: 'Third-party integrations'
  },
  {
    key: 'settings',
    route: 'settings',
    label: 'Settings',
    description: 'Company settings and configuration'
  },
  {
    key: 'agent-tasks',
    route: 'agent-tasks',
    label: 'Agent Tasks',
    description: 'AI agent tasks and automation'
  },
  {
    key: 'alerts',
    route: 'alerts',
    label: 'Alerts',
    description: 'Company alerts and notifications'
  }
]

/**
 * Get route enum values for use in AI function definitions
 */
export const getCompanyRouteEnum = (): string[] => {
  return COMPANY_ROUTES.map(route => route.route)
}

/**
 * Get route descriptions for use in AI function definitions
 */
export const getCompanyRouteDescriptions = (): string => {
  return COMPANY_ROUTES
    .map(route => `'${route.label}' is the page where ${route.description.toLowerCase()}.`)
    .join('\n    ')
}

